import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import Label from '@/components/fields/Label';
import { useTheme } from '@/contexts/ThemeContext';

export default function CheckboxField({
  id,
  name,
  children,
  className,
  checked,
  booleanValue,
  errorMessage = true,
}: {
  id: string;
  name: string;
  children: ReactNode;
  className?: string;
  checked?: boolean;
  booleanValue?: boolean;
  errorMessage?: boolean;
}): JSX.Element {
  const { register, errors } = useFormContext();
  const hasErrors = typeof errors[name] !== 'undefined';
  const { landingPage } = useTheme();

  const isDLAssistant = landingPage === 'v12' || landingPage === 'v13';

  return (
    <div className={`mt-2 mb-4 ${className}`}>
      <div className="flex">
        <input
          id={id}
          name={name}
          type="checkbox"
          className={`form-checkbox border-gray-400 ${
            isDLAssistant ? 'text-red-400' : 'text-primary'
          }  mr-2 mt-1 flex-shrink-0 ${hasErrors ? 'shadow-error' : ''}`}
          value={booleanValue ? 'true' : id}
          ref={register}
          defaultChecked={checked}
        />
        <Label id={id} isRequired={false}>
          {children}
        </Label>
      </div>
      {hasErrors && errorMessage ? (
        <p className="mt-1 text-sm text-red-600">{errors[name].message}</p>
      ) : null}
    </div>
  );
}
